module.exports = __webpack_public_path__ + "static/media/GengibreLimao_750.e2a1c3e8.jpg";